import { useSaleStatusStore } from "@/store/saleStatus";
import { useEffect } from "react";

interface TopBarProp {
  showExit?: boolean;
}

export default function TopBar({ showExit = false }: TopBarProp) {
  const { loadSale, hideMenus, setHideMenus } = useSaleStatusStore();

  useEffect(() => {
    const hideMenu = new URLSearchParams(
      document.location.search.substring(1)
    ).get("esconder_menu");

    setHideMenus(hideMenu === "1");
  }, [setHideMenus]);

  return (
    <div className="bg-tim-primary shadow-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 lg:px-8">
        <div className="lg:ml-[8.33%]">
          <img src="/tim_logo_white.svg" alt="Logo da TIM" />
        </div>

        {!hideMenus && showExit && (
          <a className="text-white" href="/" onClick={() => loadSale(undefined)}>
            SAIR
          </a>
        )}
      </div>
    </div>
  );
}
